export namespace BannerCommon {
  export enum Status {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    DELETED = 'DELETED',
  }

  export enum ModerateStatus {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
  }

  export enum DisplayCategoryPathExtendedType {
    EXACT = 'EXACT',
    PREFIX = 'PREFIX',
    EXACT_NEGATIVE = 'EXACT_NEGATIVE',
    PREFIX_NEGATIVE = 'PREFIX_NEGATIVE',
  }

  export interface DisplayCategoryPathExtended {
    path: string;
    mode: DisplayCategoryPathExtendedType;
  }
}
